import styled from "styled-components";
import { Text } from "components/Text";
import spacing from "theme/spacing.module.scss";
import { CUSTOM_CARD_TYPES } from "../types";

export const Wrapper = styled.div<{ $type: CUSTOM_CARD_TYPES }>`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    gap: ${spacing.spacingXXS};

    ${({ $type }) =>
            $type === CUSTOM_CARD_TYPES.TASKS
                    ? "display: block;"
                    : "-webkit-line-clamp: 3;"}
`;
export const StyledText = styled(Text)`
    text-decoration: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    cursor: pointer;
`;

export const StyledDescription = styled(Text)<{ $clickable?: boolean }>`
    ${({ $clickable }) => $clickable && "cursor: pointer;"}
`;
